/* BARBA FORTE — MONTE SEU KIT · runtime da section */
(function () {
  'use strict';

  var ICON_CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var ICON_GIFT = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5C9.5 3 11 5 12 8c1-3 2.5-5 4.5-5a2.5 2.5 0 0 1 0 5"></path></svg>';
  var ICON_TRUCK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>';

  function brl(cents) { return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function boot(root) {
    if (root.__bfk) return;
    root.__bfk = true;

    var cfgEl = root.querySelector('[data-bfk-config]');
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); }
    catch (e) { root.innerHTML = '<div class="bfk"><div class="bfk-err">Configuracao invalida da section.</div></div>'; return; }

    var STEPS = (CFG.steps || []).filter(function (s) { return s && s.handles && s.handles.length; });
    if (!STEPS.length) {
      root.innerHTML = '<div class="bfk"><div class="bfk-err">Nenhum passo configurado. Adicione blocos "Passo do kit" no editor de temas.</div></div>';
      return;
    }

    var DISC = Math.min(Math.max(Number(CFG.discount) || 0, 0), 90) / 100;
    var HAS_DISC = DISC > 0;
    var SUMMARY = STEPS.length;
    // O desconto visual sempre incide sobre o preco ORIGINAL (compare_at_price),
    // nunca sobre o preco ao vivo — que ja pode estar com outro desconto (ex: 10% sitewide) embutido.
    // Isso mantem o valor mostrado aqui igual ao valor real cobrado no checkout.
    function basePrice(p) { return p.compareAtPrice || p.price; }
    function off(c) { return HAS_DISC ? Math.round(c * (1 - DISC)) : c; }

    var products = {};
    var sel = STEPS.map(function () { return null; });
    var step = 0;
    var loaded = false;

    function fetchProduct(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(handle + ' HTTP ' + r.status); return r.json(); })
        .then(function (p) {
          var v = null, i;
          for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
          if (!v) throw new Error(handle + ' sem variante disponivel');
          return {
            handle: handle, title: p.title, price: v.price, compareAtPrice: v.compare_at_price || null, variantId: v.id,
            image: p.featured_image || (p.images && p.images[0]) || null,
            line: p.vendor || 'BARBA FORTE', cat: p.type || ''
          };
        });
    }

    Promise.all(STEPS.map(function (s) {
      return Promise.all(s.handles.map(function (h) {
        return fetchProduct(h).then(
          function (p) { products[h] = p; },
          function (e) { if (window.console) console.warn('[Monte Seu Kit]', e.message); }
        );
      }));
    })).then(function () { loaded = true; render(); });

    function chosen() {
      return sel.map(function (h) { return h ? products[h] : null; }).filter(Boolean);
    }
    function totals() {
      var sub = 0, tot = 0;
      chosen().forEach(function (p) { var b = basePrice(p); sub += b; tot += off(b); });
      return { sub: sub, tot: tot, save: sub - tot, count: chosen().length };
    }
    function requiredIdx() {
      var out = [], i;
      for (i = 0; i < STEPS.length; i++) { if (!STEPS[i].optional) out.push(i); }
      return out;
    }

    function imgHTML(p, mini) {
      if (p.image) return '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">';
      if (mini) return '<div class="bfk-mini">' + esc(String(p.line || 'BF').slice(0, 2)) + '</div>';
      return '<div class="bfk-ph"><b>' + esc(p.line) + '</b><span>' + esc(p.cat) + '</span></div>';
    }

    function stepperHTML() {
      var h = '<div class="bfk-stepper">', i;
      for (i = 0; i < STEPS.length; i++) {
        if (i > 0) h += '<div class="bfk-conn' + (i <= step ? ' done' : '') + '"></div>';
        var done = i < step || step === SUMMARY;
        var cls = i === step ? ' on' : (done ? ' done' : '');
        h += '<div class="bfk-step' + cls + '"><div class="bfk-dot">' + (done ? ICON_CHECK : (i + 1)) + '</div>' +
             '<div class="bfk-steplabel">' + esc(STEPS[i].label) + '</div></div>';
      }
      return h + '</div>';
    }

    function cardHTML(p) {
      var isSel = sel[step] === p.handle;
      var base = basePrice(p);
      var prices = HAS_DISC
        ? '<s class="bfk-old">' + brl(base) + '</s><span class="bfk-new">' + brl(off(base)) + '</span>'
        : '<span class="bfk-new">' + brl(base) + '</span>';
      return '<button type="button" class="bfk-card' + (isSel ? ' sel' : '') + '" data-h="' + esc(p.handle) + '">' +
        (HAS_DISC ? '<span class="bfk-badge">-' + Math.round(DISC * 100) + '%</span>' : '') +
        '<span class="bfk-check">' + ICON_CHECK + '</span>' +
        '<div class="bfk-img">' + imgHTML(p) + '</div>' +
        '<div class="bfk-info"><p class="bfk-name">' + esc(p.title) + '</p>' +
        '<div class="bfk-prices">' + prices + '</div></div></button>';
    }

    function stepHTML() {
      var s = STEPS[step];
      var h = '<div class="bfk-sthead"><h2 class="bfk-sttitle">' + esc(s.title) + '</h2>' +
              '<p class="bfk-stsub">' + esc(s.sub) + '</p></div><div class="bfk-grid">';
      if (!loaded) {
        for (var i = 0; i < s.handles.length; i++) h += '<div class="bfk-skel"></div>';
      } else {
        var any = false;
        s.handles.forEach(function (hd) { if (products[hd]) { h += cardHTML(products[hd]); any = true; } });
        if (!any) h += '<div class="bfk-err">Nao deu pra carregar os produtos deste passo. Recarrega a pagina e tenta de novo.</div>';
      }
      return h + '</div>';
    }

    function barHTML() {
      var t = totals();
      var req = requiredIdx();
      var slots = '';
      req.forEach(function (idx, n) {
        var p = sel[idx] ? products[sel[idx]] : null;
        slots += '<button type="button" class="bfk-slot' + (p ? ' fill' : '') + '" data-step="' + idx + '" ' +
                 'title="' + esc(STEPS[idx].label) + '">' + (p ? imgHTML(p, true) : (n + 1)) + '</button>';
      });
      var isLast = step === STEPS.length - 1;
      var nextLabel = isLast ? (sel[step] ? CFG.ctaFinish : CFG.ctaSkip) : CFG.ctaNext;
      var nextDisabled = !isLast && !sel[step] && !STEPS[step].optional;
      var totalBlock = HAS_DISC
        ? '<small>' + esc(CFG.totalLabel) + '</small><div>' + (t.sub ? '<s>' + brl(t.sub) + '</s>' : '') + '<b>' + brl(t.tot) + '</b></div>'
        : '<small>Total</small><div><b>' + brl(t.tot) + '</b></div>';
      return '<div class="bfk-bar"><div class="bfk-barin">' +
        '<div class="bfk-slots">' + slots + '</div>' +
        '<div class="bfk-total">' + totalBlock + '</div>' +
        '<div class="bfk-nav">' +
        (step > 0 ? '<button type="button" class="bfk-btn bfk-btn-ghost" data-nav="back">' + esc(CFG.ctaBack) + '</button>' : '') +
        '<button type="button" class="bfk-btn bfk-btn-primary" data-nav="next"' + (nextDisabled ? ' disabled' : '') + '>' + esc(nextLabel) + '</button>' +
        '</div></div></div>';
    }

    function summaryHTML() {
      var t = totals();
      var rows = '';
      sel.forEach(function (hd, i) {
        if (!hd) return;
        var p = products[hd];
        var base = basePrice(p);
        var pr = HAS_DISC ? '<s>' + brl(base) + '</s><b>' + brl(off(base)) + '</b>' : '<b>' + brl(base) + '</b>';
        rows += '<div class="bfk-row"><div class="bfk-rimg">' + imgHTML(p, true) + '</div>' +
          '<div class="bfk-rname"><small>' + esc(STEPS[i].label) + '</small>' + esc(p.title) + '</div>' +
          '<div class="bfk-rprices">' + pr + '</div></div>';
      });
      var lines = '<div class="bfk-trow"><span>Subtotal (' + t.count + ' produtos)</span>' +
                  (HAS_DISC ? '<s>' + brl(t.sub) + '</s>' : '<span>' + brl(t.sub) + '</span>') + '</div>';
      if (HAS_DISC) {
        lines += '<div class="bfk-trow save"><span>Desconto (' + Math.round(DISC * 100) + '%)</span><span>&minus;' + brl(t.save) + '</span></div>';
      }
      lines += '<div class="bfk-trow final"><span>Total do kit</span><b>' + brl(t.tot) + '</b></div>';
      return '<div class="bfk-sum">' +
        '<div class="bfk-sthead"><h2 class="bfk-sttitle">' + esc(CFG.summaryTitle) + '</h2>' +
        '<p class="bfk-stsub">' + esc(CFG.summarySub) + '</p></div>' +
        '<div class="bfk-sumlist">' + rows + '</div>' +
        (CFG.showGift ? '<div class="bfk-gift">' + ICON_GIFT + '<div><b>' + esc(CFG.giftTitle) + '</b><span>' + esc(CFG.giftSub) + '</span></div></div>' : '') +
        (CFG.showShipping ? '<div class="bfk-ship">' + ICON_TRUCK + esc(CFG.shippingText) + '</div>' : '') +
        '<div class="bfk-totals">' + lines + '</div>' +
        '<button type="button" class="bfk-finish" data-checkout>' + esc(CFG.ctaFinish) + '</button>' +
        '<div class="bfk-status" data-status></div>' +
        '<button type="button" class="bfk-backlink" data-nav="back">&larr; ' + esc(CFG.ctaBack) + ' e trocar algum produto</button>' +
        '</div>';
    }

    function render() {
      var h = '<div class="bfk"><header class="bfk-head">' +
        (CFG.eyebrow ? '<p class="bfk-eyebrow">' + esc(CFG.eyebrow) + '</p>' : '') +
        '<h1 class="bfk-title">' + CFG.title + '</h1><div class="bfk-rule"></div>' +
        (CFG.sub ? '<p class="bfk-sub">' + esc(CFG.sub) + '</p>' : '') +
        '</header>';
      h += stepperHTML();
      h += step === SUMMARY ? summaryHTML() : stepHTML();
      h += '</div>';
      h += step < SUMMARY ? barHTML() : '';
      var cfg = root.querySelector('[data-bfk-config]');
      root.innerHTML = '';
      if (cfg) root.appendChild(cfg);
      root.insertAdjacentHTML('beforeend', h);
    }

    function scrollTop() {
      var y = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 8;
      window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
    }

    function checkout() {
      var btn = root.querySelector('[data-checkout]');
      var status = root.querySelector('[data-status]');
      var items = chosen().map(function (p) { return { id: p.variantId, quantity: 1 }; });
      if (!items.length) { status.className = 'bfk-status err'; status.textContent = 'Escolhe pelo menos um produto.'; return; }
      btn.disabled = true;
      btn.textContent = 'ADICIONANDO AO CARRINHO...';
      status.textContent = ''; status.className = 'bfk-status';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
          return r.json();
        })
        .then(function () { window.location.href = CFG.cartRedirect || '/cart'; })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = CFG.ctaFinish;
          status.className = 'bfk-status err';
          status.textContent = 'Nao deu pra adicionar: ' + e.message + ' - tenta de novo.';
        });
    }

    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var card = t.closest('.bfk-card');
      if (card) { var h = card.getAttribute('data-h'); sel[step] = sel[step] === h ? null : h; render(); return; }
      var slot = t.closest('.bfk-slot');
      if (slot) { step = parseInt(slot.getAttribute('data-step'), 10) || 0; render(); scrollTop(); return; }
      var nav = t.closest('[data-nav]');
      if (nav) {
        if (nav.getAttribute('data-nav') === 'back') step = Math.max(0, step - 1);
        else if (step === STEPS.length - 1 || sel[step] || STEPS[step].optional) step = Math.min(SUMMARY, step + 1);
        render(); scrollTop(); return;
      }
      if (t.closest('[data-checkout]')) checkout();
    });

    render();
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-bfk]');
    for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelector('[data-bfk]');
    if (n) { n.__bfk = false; boot(n); }
  });
})();
